<template>
    <dx-tooltip
        id="global-app-tooltip"
        ref="globalTooltip"
        :hide-on-outside-click="false"
        hide-event="mouseleave"
        position="bottom"
        show-event="mouseenter"
    >
        {{ tooltipText }}
    </dx-tooltip>
</template>

<script>
export default {
    name: 'ai-global-tooltip',
};
</script>

<script setup>
import { ref } from 'vue';

import { DxTooltip } from 'devextreme-vue';

const globalTooltip = ref();
const tooltipText = ref('-');

const show = (element, text) => {
    tooltipText.value = text;
    globalTooltip.value.instance.show(element);
}

defineExpose({
    show,
});
</script>

<style scoped>

</style>
